import styled from 'styled-components';

export const EapSettingsRowOptionsStyled = styled.div`
    display: flex;
`;
